import styles from './index.module.scss'
import { Input, Popover, Upload, message } from 'antd';
import { useEffect, useState } from 'react';
import Utils from '@utils/utils'
import Iconfont from '@utils/Iconfont'
import PSAIModal from '@PSAIComponents/PSAIModal';
import { UploadOutlined, DeleteOutlined, SearchOutlined, LoadingOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const SelectionFilterSearch = (props) => {
    const { onChange } = props
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [imageUrl, setImageUrl] = useState('')

    const onSearch = value => {
        if (!value) return
        onChange && onChange(value)
        setOpen(false)
    }

    const uploadFile = (file) => {
        return Utils.checkImageIslegal(file, 1).then(res => {
            if (!res) return false
            if (!res.isLegal) {
                PSAIModal.confirm({
                    content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                    okText: '重新上传',
                    cancelText: '取消',
                    onOk() {
                        Utils.openFile().then((res) => {
                            if (res) beforeUpload(res)
                        })
                    },
                    onCancel() { },
                })
                return false
            } else {
                const { imageAntispamId, data } = res
                return {
                    url: data,
                    imageAntispamId
                }
            }
        }).catch((err) => {
            message.error(err.message)
        })
    }
    // 将大图换成jpg、1024 格式
    const processImage = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                const img = new Image();
                img.src = e.target.result;
                img.onload = () => {
                    const maxDim = 1024;
                    let width = img.width;
                    let height = img.height;
                    let needResize = false;

                    if (width > maxDim || height > maxDim) {
                        needResize = true;
                        if (width > height) {
                            height = Math.round((height * maxDim) / width);
                            width = maxDim;
                        } else {
                            width = Math.round((width * maxDim) / height);
                            height = maxDim;
                        }
                    }

                    const isPng = file.type === 'image/png';

                    if (!needResize && !isPng) {
                        resolve(file);
                        return;
                    }

                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = width;
                    canvas.height = height;

                    if (isPng) {
                        ctx.fillStyle = '#FFFFFF';
                        ctx.fillRect(0, 0, width, height);
                    }

                    ctx.drawImage(img, 0, 0, width, height);

                    let targetType = file.type;
                    let fileName = file.name;
                    if (isPng) {
                        targetType = 'image/jpeg';
                        fileName = fileName.replace(/\.png$/i, '.jpg');
                    }

                    canvas.toBlob((blob) => {
                        if (blob) {
                            const newFile = new File([blob], fileName, { type: targetType });
                            resolve(newFile);
                        } else {
                            reject(new Error('Image processing failed'));
                        }
                    }, targetType, 0.9);
                };
                img.onerror = reject;
            };
            reader.onerror = reject;
        });
    }

    const doUpload = async (file) => {
        setLoading(true)
        try {
            const isJpgOrPng = file.type === 'image/jpeg' ||
                file.type === 'image/png' ||
                file.type === 'image/webp'
            if (!isJpgOrPng) { message.error('您只能上传JPG/PNG/WEBP格式的文件！'); return false }
            const isLt30M = file.size / 1024 / 1024 < 30;
            if (!isLt30M) { message.error('图片不能超过30M!'); return false }

            const processedFile = await processImage(file)
            const res = await uploadFile(processedFile)
            if (!res) return false
            const { url } = res
            return url
        } catch (err) {
            return false
        } finally {
            setLoading(false)
        }
    }

    const uploadProps = {
        name: 'file',
        accept: 'image/jpeg,image/png,image/webp',
        multiple: false,
        showUploadList: false,
        beforeUpload: async (file) => {
            const res = await doUpload(file)
            if (res) {
                onChange && onChange(res)
                setImageUrl(res)
                setSearchValue('')
                setOpen(false)
            }
            return false;
        },
    }

    const content = (
        <div className={styles.customDropdown}>
            <div className={styles.uploadWrapper}>
                <Dragger {...uploadProps}>
                    <p className={styles.uploadText}>
                        <UploadOutlined /> 上传图片
                    </p>
                    <p className={styles.uploadHint}>拖拽图片至此处或点击上传图片</p>
                </Dragger>
            </div>
        </div>
    )

    const clearImage = (e) => {
        e.stopPropagation()
        setImageUrl('')
        onChange && onChange('')
    }

    useEffect(() => {
        if (!searchValue) onChange('')
    }, [searchValue])

    const prefix = imageUrl ? (
        <div className={styles.prefixImageWrapper}>
            <img src={Utils.getImgThumbnail(imageUrl)} alt="uploaded" className={styles.prefixImage} />
            <div className={styles.deleteOverlay} onClick={clearImage}>
                <DeleteOutlined style={{ color: '#fff', fontSize: '12px' }} />
            </div>
        </div>
    ) : (
        <Popover
            content={content}
            trigger="click"
            open={open}
            onOpenChange={setOpen}
            placement="bottomLeft"
            className={styles.SelectionFilterSearchPopover}
            arrow={false}
        >
            <div className={styles.uploadIconWrapper}>
                <Iconfont type="icon-cameraOutlined" style={{ fontSize: '16px', marginRight: '8px' }} />
                以图搜图
            </div>
        </Popover>
    )

    return (
        <div className={styles.SelectionFilterSearch}>
            <Input
                maxLength={200}
                className={styles.SelectionFilterSearchSelect}
                placeholder="搜索内容"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                allowClear={!imageUrl}
                onPressEnter={(e) => onSearch(e.target.value)}
                suffix={
                    loading ? (
                        <LoadingOutlined style={{ color: '#999' }} />
                    ) : (
                        <SearchOutlined
                            style={{ fontSize: '16px', color: '#999', cursor: 'pointer' }}
                            onClick={() => onSearch(searchValue)}
                        />
                    )
                }
            />
            {prefix}
        </div>
    )
}

export default SelectionFilterSearch
